<template>
  <div class="container">
    <van-cell-group>
      <van-field v-model="obj.content" rows="1" autosize type="textarea" readonly label="心愿内容" />
      <van-field v-model="obj.name" readonly label="姓名" />
      <van-field v-model="obj.mobile" readonly label="联系方式" />
      <van-field v-model="obj.address" rows="1" autosize type="textarea" readonly label="联系地点" />
      <van-field v-model="address" rows="1" autosize type="textarea" readonly label="所在区域" />
      <van-field v-model="obj.memo" rows="1" autosize type="textarea" readonly label="备注" />
      <van-field v-model="obj.state_str" readonly label="审核状态" />
      <van-field v-if="obj.unpass_reason" v-model="obj.unpass_reason" rows="1" autosize type="textarea" readonly label="驳回理由" />
    </van-cell-group>
  </div>
</template>
<script>
export default {
  name:'wishcheck',
  data() {
    return{
      //content:'',
      //name:'',
      //mobile:'',
      //contact_address:'',
      address:'',
      //memo:'',
      //state:'', 
      obj:{}
    }
  },
  created(){
    this.$axios({
      method:'post',
      url:'/api/task/wish_detail',
      data:this.qs.stringify({
        zjy_uid:sessionStorage.getItem('uid'),
        id:this.$route.query.id,
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        this.obj = res.data.data;
        this.address = '江阴市-' + res.data.data.street_str + '-' + res.data.data.village_str;
      }else{
        this.$toast(res.data.msg);
      }
    })
  }
}
</script>
<style scoped>
.container{
  min-height: 100vh;
  background: #f2f2f2;
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/wishcheck.vue